export const stringReducer = (element: any) => {
  const result = element.reduce((unique: { text: string; value: string }[], o: { text: string; value: string }) => {
    if (
      !unique.some((obj: { text: string; value: string }) => obj.text === o.text && obj.value === o.value) &&
      o.text !== null &&
      o.text !== '-' &&
      o.text !== ''
    ) {
      unique.push(o);
    }

    return unique;
  }, []);
  return result.sort((a: { text: string; value: string }, b: { text: string; value: string }) =>
    a.text > b.text ? 1 : -1,
  );
};
